// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2bab7709","703":"6a3ef51e"}[chunkId] + ".chunk.js";
};